module.exports = __webpack_public_path__ + "static/media/close.b541b79c.svg";